import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import './styles/tooltip.scss';

const Tooltip = (props) => (
  <div className={`tooltip-component ${props.className}`}>
    <span
      data-delay-show={props.delayShow}
      data-effect={props.effect}
      data-for={props.tooltipId}
      data-offset={props.offset}
      data-place={props.placement}
      data-tip=""
    >
      {props.children}
    </span>
    <ReactTooltip id={props.tooltipId} type={props.type}>
      <span className="tooltip-red">
        {props.tooltipContent}
      </span>
    </ReactTooltip>
  </div>
);

export default Tooltip;

Tooltip.defaultProps = {
  className: '',
  delayShow: 0,
  effect: 'solid', // options: solid, float
  offset: null, // e.g. `{'left': 10}` (syntax is important here)
  placement: 'top',
  tooltipContent: '',
  tooltipId: '',
  type: 'dark', // options: dark, light
};

Tooltip.propTypes = {
  className: PropTypes.string,
  delayShow: PropTypes.number,
  effect: PropTypes.string,
  offset: PropTypes.string,
  placement: PropTypes.string,
  tooltipContent: PropTypes.string,
  tooltipId: PropTypes.string,
  type: PropTypes.string,
};
